export enum WageReimbursementImportance {    
    NoImportance = 5,
    SomeImportance = 10,
    HighImportance = 15,
    KeyImportance = 20
}